module.exports = __webpack_public_path__ + "img/p1.ee568b65.png";